import { createOrder, verifyPayment } from "../api";

const SCRIPT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

const loadScript = () =>
  new Promise((resolve) => {
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
      resolve(true);
      return;
    }
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

/**
 * Starts the Razorpay ₹99 checkout.
 * Returns { ok: true, user } on verified payment,
 * or { ok: false, reason } on failure/cancel/misconfig.
 */
export const startCheckout = async () => {
  let order;
  try {
    order = await createOrder();
  } catch (e) {
    const status = e?.response?.status;
    const detail = e?.response?.data?.detail;
    if (status === 503) return { ok: false, reason: "not_configured", detail };
    if (status === 400) return { ok: false, reason: "already_premium", detail };
    return { ok: false, reason: "order_failed", detail };
  }

  const loaded = await loadScript();
  if (!loaded) return { ok: false, reason: "script_failed" };

  return new Promise((resolve) => {
    const options = {
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      name: "dilli.wiki",
      description: "Premium — unlock Submit a spot",
      order_id: order.order_id,
      prefill: { email: order.email },
      theme: { color: "#171717" },
      handler: async (res) => {
        try {
          const user = await verifyPayment({
            razorpay_order_id: res.razorpay_order_id,
            razorpay_payment_id: res.razorpay_payment_id,
            razorpay_signature: res.razorpay_signature,
          });
          resolve({ ok: true, user });
        } catch (e) {
          resolve({ ok: false, reason: "verify_failed" });
        }
      },
      modal: {
        ondismiss: () => resolve({ ok: false, reason: "dismissed" }),
      },
    };
    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", () => resolve({ ok: false, reason: "payment_failed" }));
    rzp.open();
  });
};
